export default {
	wei_zhi: "Location",
	zhu_ye: "Home",
	sheng_chan_ri_qi: "製造年月",
	ext_yan_se: "外装色",
	int_yan_se: "内装色",
	wei_zhao_dao_shu_ju: "該当データは見つかりませんでした",
	xuan_ze_zhu_zu_xi_fen: "メイングループを選択してください",
	ji_shu: "件数",
	sou_suo_jie_guo: "検索結果",
	che_liang_dai_ma: "車台番号",
	che_liang_xin_xi: "車両情報",
	pin_pai: "プランド",
	xing_hao_ming_cheng: "モデル名",
	sheng_chan_ri_qi_1: "製造日",
	sheng_chan_shang: "メーカー",
	mo_xing: "ブランド",
	"SOP-EOP-": "SOP-EOP-",
	di_pan_dai_ma: "型式",
	deng_ji: "グレード",
	bian_su_qi_lei_xing: "トランスミッション",
	jia_shi_yuan_zhi_wei: "ドライバーズ ポジション",
	che_liang_lei_xing: "車両タイプ",
	men: "ドア数",
	fa_dong_ji_xing_hao: "エンジンモデル",
	qu_dai: "排気量",
	gong_shuai_Kw: "パワーKw",
	ran_liao_lei_xing: "燃料タイプ",
	qu_dong_qi_xing_hao: "ドライブモデル",
	"xin_10-1234567": "ZNE10-1234567 型",
	che_liang_sou_suo: "車両検索",
	pin_pai_xing_hao: "「モデル」「モデル」",
	xin_10: "ー",
	xing_hao_biao_shi_hao: "ー",
	fen_lei_bian_hao: "ー",
	shu_ru_zhi_shao_7_wei_OE_dai_ma: "OE コードは 7 桁以上で入力してください",
	di_pan_dai_ma_1: "型式",
	huan_ying: "Welcome",
	ji_de: "ログイン情報を保持する",
	wang_ji: "パスワードを忘れた場合",
	zhu_ce: "ログイン",
	yong_hu_ming: "ユーザー名",
	mi_ma: "パスワード",
	qing_shu_ru_yong_hu_ming: "ユーザー名を入力してください",
	qing_shu_ru_zheng_que_de_yong_hu_ming: "正しいユーザー名を入力してください",
	qing_shu_ru_mi_ma: "パスワードを入力してください",
	qing_shu_ru_zheng_que_de_mi_ma: "正しいパスワードを入力してください",
	yong_hu_ming_huo_mi_ma_cuo_wu: "ユーザー名またはパスワードが正しくありません",
	fan_hui: "Back",
	bei_zhu: "Remark",
	bu: "いいえ",
	zhu_zu: "メイングループ",
	hou_guo: "結果",
	"pin_pai_ming_cheng_/_xing_hao_ming_cheng": "ブランド/モデル名",
	yi_jian_sou_suo_te_ding_xiang_mu: "特定品目一発検索",
	yi_sun_ling_jian: "ー",
	wai_guan_ling_jian: "ー",
	OEM_xin_xi: "OEM情報",
	OEM_dai_ma: "OEMコード",
	OEM_ming_cheng: "OEM名",
	qing_mei_su: "PNC",
	geng_huan_ling_jian_xin_xi: "互換品番情報",
	jia_ge: "価格",
	xing_xiang: "イメージ",
	OES_pin_pai: "OESモデル",
	OES_dai_ma: "OESコード",
	OES_ming_cheng: "OES名",
	guo_jia: "国",
	OEM_dai_ma_1: "OEMコード",
	OEM_ming_cheng_1: "OEM名",
	pin_pai_1: "プランド",
	mo_xing_1: "モデル",
	ji_xiang___dai_ma: "型式",
	kai_shi_shi_jian: "開始年月",
	jie_shu_shi_jian: "終了年月",
	fa_dong_ji: "エンジン",
	bian_su_qi: "トランスミッション",
	cha_tu: "イラスト",
	OES_ling_jian_qing_dan: "OES部品リスト",
	jian_rong_xing_hao_lie_biao: "対応モデル一覧",
	fa_dong_ji_he_bian_su_qi: "エンジン＆トランスミッション部品関連",
	di_pan_he_xuan_jia: "駆動&足廻り部品関連",
	wai_bu_he_nei_bu: "外装＆内装部品関連",
	pan_shi_zhi_dong_pian: "ディスクブレーキパッド",
	pan_shi_zhuan_zi: "ディスクローター",
	zhi_dong_ti: "ブレーキシュー",
	zhi_dong_zong_beng: "ブレーキマスターシリンダー",
	chuan_dong_zhou_fang_chen_tao: "ドライブシャフトブーツ",
	lun_gu_zhou_cheng: "ハブベアリング",
	hou_xiao_yin_qi: "リアマフラー",
	jian_zhen_qi: "ショックアブソーバー",
	wen_ding_qi_lian_gan: "スタビライザーリンク",
	chuan_dong_zhou_zong_cheng: "ドライブシャフトASSY",
	chi_lun_chi_tiao: "ラックアンドピニオン",
	ji_you_lv_qing_qi: "オイルフィルター",
	kong_qi_lv_qing_qi: "エアクリーナー",
	shui_beng: "ウォーターポンプ",
	li_he_qi_gai: "クラッチカバー",
	li_he_qi_pian: "クラッチディスク",
	"huo_hua_sai_/_dian_re_sai": "スパーク/グロープラグ",
	yang_qi_chuan_gan_qi: "O2センサー",
	fa_dong_ji_zong_cheng: "エンジンASSY",
	bian_su_qi_zong_cheng: "トランスミッションASSY",
	qi_dong_ji_dian_ji: "スターターモーター",
	leng_que_qi_ya_suo_ji: "クーラーコンプレッサー",
	bian_ju_qi: "トルクコンバーター",
	kong_tiao_lv_qing_qi: "クリーンフィルター",
	qian_men: "フロントドア",
	hou_men: "リアドア",
	qian_zhao_deng: "ヘッドランプ",
	qian_bao_xian_gang: "フロントバンパー",
	hou_bao_xian_gang: "リアバンパー",
	wei_deng: "テールランプ",
	hou_bo_li: "リアガラス",
	ce_shi_jing: "サイドミラー",
	production_date: "製造年月",
	belts: "ベルト類",
	battery: "バッテリー",
	radiator: "ラジエーター",
	alternator: "オルタネーター",
	wiper: "ワイパー",
	oe_name: "OE名",
	start_end: "開始年月/終了年月",
	oem_code: "OEMコード",
	group_name_subgroup_name: "グループ名/サブグループ名",
	sop: "開始年月",
	eop: "終了年月",
	oem_code_substitution_code: "OEMコード/互換品番",
	oem_name_remark: "OE名/REMARK",
	oes_code: "OESコード",
	model: "ブランド",
	grade: "グレード",
	transmission_type: "トランスミッション",
	drivers_position: "ドライバーズ ポジション",
	engine_model: "エンジンモデル",
	displacement: "排気量",
	windshield: "フロントガラス",
};
